import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list'; 
import googleCalendarPlugin from '@fullcalendar/google-calendar';

import '../css/calendar.css';

const Calendar = () => {
  const [currentView, setCurrentView] = useState('dayGridMonth');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCurrentView('listMonth');
      } else {
        setCurrentView('dayGridMonth');
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="apc-calendar-wrapper">
      <FullCalendar
        key={currentView} 
        plugins={[dayGridPlugin, listPlugin, googleCalendarPlugin]}
        initialView={currentView}
        
        // 1. Add your Google API Key here
        googleCalendarApiKey="AIzaSyDhIIz9I3oW_0ZhC3XjIPqSSjFFMlmYNuM"

        

        // 2. This is the fix for the 'eventSources' error
        eventSources={[
          {
            googleCalendarId: 'albuquerkypressclub@gmail.com',
            className: 'apc-events',
            color: '#417fa8c8' // Blue for Club events
          },
        //  {
          //  googleCalendarId: 'e286b25a4afdead4d9863615f23fa55e19c27d548d9b1d89b706a8b741e89c74@group.calendar.google.com',
           // className: 'personal-events',
           // color: '#ef94d2', // Green for Personal events
      
         // }
        ]}

        headerToolbar={{
          left: 'prev,next',
          center: 'title',
          right: window.innerWidth < 768 ? 'listWeek' : 'dayGridMonth,dayGridWeek' 
        }}
        height="auto"
      />
    </div>
  );
};

export default Calendar;